<app-base-widget [cardClass]="'bg-white'">
    <mat-tab-group animationDuration="0" (selectedTabChange)="handleChange($event)">
        @for (tab of visibleTabs(); track tab.id) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div header class="flex">{{tab.label}}
                        <app-info-icon tooltipPosition="above" tooltipClass="info-icon-top-8"
                            [tooltipInfo]="tab.tooltip">
                        </app-info-icon>
                    </div>
                </ng-template>
                <ng-template matTabContent>
                    @if (tab.type === 'geography') {
                        <app-base-geography-widget [widgets]="widgets()" [currency]="currency() ?? 'USD'" [showUSMapWidget]="showUSMapWidget()" [otherCountryNames]="otherCountryNames()"></app-base-geography-widget>
                    } @else {
                        <app-base-widget [card]="false" [error]="tab.error ?? ''" [attr.data-cy]="tab.chartDataCy">
                            <span class="remaining-value-text">By Remaining Value</span>
                            <app-gcm-chart [chartData]="tab.chartData ?? null" [chartType]="tab.chartType ?? null" [chartStyle]="chartStyle"
                                [chartOptions]="tab.chartOptions ?? null"></app-gcm-chart>
                        </app-base-widget>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</app-base-widget>
